import React, { memo } from "react";
import colors from "app/colors";
import { SendChatIcon } from "modules/icons";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { IconButton, Spinner } from "@chakra-ui/react";

interface IProps {
  draftId: string;
  onSend: () => void;
  isSending?: boolean;
}

const ComposeBottomToolbarSendTaskButton = ({
  draftId,
  onSend,
  isSending,
}: IProps) => {
  const {
    draft,
    isDraftLoaded,
    bottomButtonTypes,
    isUploadingFiles,
    canSendMessage,
  } = useMessageThreadDraft({ draftId });

  if (!draft || !isDraftLoaded) return null;

  if (!bottomButtonTypes.includes("send-task")) {
    return null;
  }

  const isLoading = isUploadingFiles || isSending;

  return (
    <IconButton
      title="Send message"
      variant="hover"
      size="sm"
      rounded="full"
      color={colors.gray40}
      icon={<SendChatIcon fill={colors.greenPrimary} boxSize={8} />}
      onClick={onSend}
      tabIndex={-1}
      aria-label="Send message"
      isLoading={isLoading}
      isDisabled={!canSendMessage}
      spinner={<Spinner size="sm" color="white" speed="0.65s" />}
    />
  );
};

export default memo(ComposeBottomToolbarSendTaskButton);
